import { render, staticRenderFns } from "./person-mobile-business-card-preview.vue?vue&type=template&id=505b6f8a&lang=pug&"
import script from "./person-mobile-business-card-preview.vue?vue&type=script&lang=js&"
export * from "./person-mobile-business-card-preview.vue?vue&type=script&lang=js&"
import style0 from "./person-mobile-business-card-preview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports